interface IPopupItems {
    label:string;
    name:string;
    component:string;
    options?:any;
}


export const PopupItems: IPopupItems[] = [
    {
        label:"filter.orderDate",
        name:"orderDate",
        component:"date",
    },
    // {
    //     label:"מועדון",
    //     name:"club",
    //     component:"select",
    // },
    // {
    //     label:"סדרה",
    //     name:"series",
    //     component:"select",

    // }, 
    // {
    //     label:"תעריף כרטיס",
    //     name:"price",
    //     component:"price",
    // },
    {
        label:"filter.priceBand",
        name:"priceBand",
        component:"select",
    },
    {
        label:"filter.stadium",
        name:"stadium",
        component:"select",
    },
    {
        label:"filter.area",
        name:"area",
        component:"select",
    },
    {
        label:"filter.event",
        name:"event",
        component:"select",
    },
]